import PropTypes from 'prop-types';
import { createContext, useMemo, useReducer, useState } from 'react';
import { peerFilterReducer } from '../../functions/filtering';

/* Mapping between filter type and name in DynamoDB */
export const FILTER_IDS = {
    FUND_TYPE: 'fundType',
    GEOGRAPHY: 'geoCategory',
    STYLE: 'style',
    MARKET_CAP: 'marketCapFocus'
};
/* Possible actions to perform on current filter state context */
export const PEER_FILTER_ACTIONS = {
    SET_OPTIONS: 'setOptions',
    SET_FILTERS: 'setFilters',
    CLEAR_FILTERS: 'clearFilters'
};

/** @component
 * Wrapper providing the setup for the filter states context.
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
const FilterStatesContextWrapper = ({ children }) => {
    const [peerFilterStates, peerFilterDispatch] = useReducer(
        peerFilterReducer,
        {
            filters: {
                [FILTER_IDS.FUND_TYPE]: { value: [], options: [] },
                [FILTER_IDS.GEOGRAPHY]: { value: [], options: [] },
                [FILTER_IDS.STYLE]: { value: [], options: [] },
                [FILTER_IDS.MARKET_CAP]: { value: [], options: [] }
            },
            optionsUpdated: false
        }
    );

    const [searchState, setSearchState] = useState(null);

    const filterState = useMemo(
        () => ({
            peerFilterStates,
            peerFilterDispatch,
            searchState,
            setSearchState
        }),
        [peerFilterStates, peerFilterDispatch, searchState, setSearchState]
    );

    return (
        <FilterStatesContext.Provider value={filterState}>
            {children}
        </FilterStatesContext.Provider>
    );
};

FilterStatesContextWrapper.propTypes = {
    children: PropTypes.object
};

export default FilterStatesContextWrapper;
export const FilterStatesContext = createContext();
